<template>
  <div class="partners">
    <CContainer>
      <h2 class="hero-title text-white">С нами сотрудничают</h2>
      <h4 class="sub-title">
        Организации, которые доверили нам учёт абонентов
      </h4>

      <div class="partners-grid">
        <div v-for="client in clients" :key="client.id" class="partner-card">
          <div class="partner-logo">
            <img
              :src="client.logo || defaultLogo"
              :alt="client.name"
              @error="onImageError($event)"
            />
          </div>
          <div class="partner-name">{{ client.name }}</div>
        </div>
      </div>
    </CContainer>
  </div>
</template>

<script setup>
const DEFAULT_LOGO = '/img/partners/placeholder.svg'

const defaultLogo = DEFAULT_LOGO
const clients = [
  {
    id: 1,
    name: 'Аманат Таза-Суу М.И.',
    logo: 'https://suu.net.kg/uploads/images/thumbnail/amanat.png',
  },
  {
    id: 2,
    name: 'Аманат Тазалык М.И.',
    logo: 'https://suu.net.kg/uploads/images/thumbnail/amanat.png',
  },
  { id: 3, name: 'ИСКАКБ «Зарбдар»', logo: null },
  { id: 4, name: 'Кара-Суу Таза Суу', logo: null },
  {
    id: 5,
    name: 'Кара-Суу Тазалык',
    logo: 'https://suu.net.kg/uploads/images/thumbnail/kara-suu-tazalyk.jpeg',
  },
  {
    id: 6,
    name: 'МП Ала-тоо Таза Суу',
    logo: 'https://suu.net.kg/uploads/images/thumbnail/ala-too.jpeg',
  },
  { id: 7, name: 'МП Барпы Таза Суу', logo: null },
  { id: 8, name: 'МП Барпы Тазалык', logo: null },
  { id: 9, name: 'МП Баткен Тазалык', logo: null },
  {
    id: 10,
    name: 'МП Датка Таза Суу',
    logo: 'https://suu.net.kg/uploads/images/thumbnail/datka-suu.jpg',
  },
  { id: 11, name: 'МП Отуз Адыр Таза Суу', logo: null },
  { id: 12, name: 'МП Отуз Адыр Тазалык', logo: null },
  { id: 13, name: 'Савай Таза Суу', logo: null },
  { id: 14, name: 'Савай Тазалык', logo: null },
]
const onImageError = (event) => {
  event.target.src = this.defaultLogo
}
</script>

<style lang="scss" scoped>
.hero-title {
  text-align: center;
  font-size: 2.5rem;
  letter-spacing: 1px;
  font-family: 'Vollkorn', serif;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 50px;
  position: relative;

  &::after {
    position: absolute;
    content: '';
    width: 60px;
    height: 4px;
    background: linear-gradient(90deg, #3498db, #9b59b6);
    border-radius: 2px;
    bottom: -15px;
    left: 50%;
    transform: translateX(-50%);
  }
}

.sub-title {
  font-family: 'Vollkorn', serif;
  text-align: center;
  font-size: 1.3rem;
  color: #a2a2c2;
  margin: -20px auto 40px auto;
}

.partners {
  background-color: #171321;
  padding: 80px 0;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(52, 152, 219, 0.3),
      rgba(155, 89, 182, 0.3),
      transparent
    );
  }
}

.partners-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 24px;
  margin-top: 20px;
}

.partner-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 16px;
  padding: 28px 20px 22px;
  text-align: center;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    background: rgba(255, 255, 255, 0.06);
    border-color: rgba(52, 152, 219, 0.35);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.25);

    .partner-logo {
      border-color: rgba(155, 89, 182, 0.4);
      background: rgba(255, 255, 255, 0.08);
    }
  }
}

.partner-logo {
  width: 90px;
  height: 90px;
  flex-shrink: 0;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  padding: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
}

.partner-name {
  font-size: 0.95rem;
  color: #e2e2ec;
  font-weight: 500;
  line-height: 1.35;
  min-height: 2.7em;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media screen and (max-width: 992px) {
  .hero-title {
    font-size: 2rem;
  }

  .sub-title {
    font-size: 1.1rem;
  }

  .partners-grid {
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 16px;
  }
}

@media screen and (max-width: 576px) {
  .hero-title {
    font-size: 1.7rem;
  }

  .partners {
    padding: 60px 0;
  }

  .partners-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .partner-logo {
    width: 72px;
    height: 72px;
    padding: 10px;
  }

  .partner-name {
    font-size: 0.85rem;
  }
}
</style>
